import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInfoOutlined = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 17,
	height: 16,
	viewBox: "0 0 17 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M3.83333 2C3.098 2 2.5 2.598 2.5 3.33333V12.6667C2.5 13.402 3.098 14 3.83333 14H13.1667C13.902 14 14.5 13.402 14.5 12.6667V3.33333C14.5 2.598 13.902 2 13.1667 2H3.83333ZM3.83333 3.33333H13.1667L13.168 12.6667H3.83333V3.33333ZM7.83333 4.66667V6H9.16667V4.66667H7.83333ZM7.83333 7.33333V11.3333H9.16667V7.33333H7.83333Z",
		fill: "black",
		fillOpacity: .6
	})]
});
const ForwardRef = forwardRef(SvgInfoOutlined);
export { ForwardRef as ReactComponent };
